module.exports = __webpack_public_path__ + "img/settings-horizontal.7b2f125b.svg";